import React, { Component, Suspense, useEffect } from "react";
import PropTypes from "prop-types";
import AllRoutes from "./routes";
import { connect } from "react-redux";
// import { pdfjs } from "react-pdf";
import { Navigate, useLocation } from "react-router-dom";
import JwtProvider from "./customhooks/JwtProvider";
import { GlobalDebug } from "./utils/remove-console";
import TooManyRequestModal from "./utils/tooManyRequestModal";
import InactivityHandler from "./utils/InactivityHandler";
// pdfjs.GlobalWorkerOptions.workerSrc =
//   `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  import "./App.css";


// ================================================================================
const checkAuth = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    console.log("Check auth returns False");
    return false;
  }
  console.log("token found : ", token);
  console.log("Check auth returns True");
  return true;
};

const AuthRoute = ({ children }) => {
  checkAuth() ? children : <Navigate to="/signin" />;
};

const RemoveTokenOnSignin = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/signin") {
      try {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("authUser");
        localStorage.removeItem("brandingPopUpClosed");
        delete axios.defaults.headers.common.Authorization;
        window.dispatchEvent(new CustomEvent('APP_CLEARED_TOKEN'));
        console.log('RemoveTokenOnSignin: cleared tokens and auth header');
      } catch (e) {}
    }
  }, [pathname]);
  return null;
};

// useEffect(() => {
//   const gtm = document.createElement("script");
//   gtm.src = "https://www.googletagmanager.com/gtm.js?id=GTM-WT4RPQW4";
//   gtm.async = true;
//   document.head.appendChild(gtm);

//   // Hotjar
//   const hj = document.createElement("script");
//   hj.src = "https://static.hotjar.com/c/hotjar-5018528.js?sv=6";
//   hj.async = true;
//   document.head.appendChild(hj);
// }, []);

class App extends Component {
  componentDidMount() {
    (process.env.NODE_ENV === "production" ||
     process.env.REACT_APP_ENV === "STAGING") &&
      GlobalDebug(false);
  }
  render() {
    return (
      <React.Fragment>
        <JwtProvider>
          <Suspense
            fallback={
              <div>
                <div className="loader"></div>
              </div>
            }
          >
            <InactivityHandler />
            <TooManyRequestModal>
              {<AllRoutes />}
            </TooManyRequestModal>
          </Suspense>
        </JwtProvider>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  user_id: PropTypes.string,
  userRole: PropTypes.string
};

function mapStateToProps(state) {
  if (state.user) {
    return {
      user_id: state.user.id,
      userRole: state.user.role
    };
  }
  return {};
}
export default connect(mapStateToProps, {})(App);



// import React, { Component, Suspense, useEffect } from "react";
// import PropTypes from "prop-types";
// import AllRoutes from "./routes";
// import { connect } from "react-redux";
// import Loading from "./pages/loadingpage";
// import { pdfjs } from "react-pdf";
// import { Navigate, useLocation } from "react-router-dom";
// import JwtProvider from "./customhooks/JwtProvider";
// import { GlobalDebug } from "./utils/remove-console";
// import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
// import TooManyRequestModal from "./utils/tooManyRequestModal";
// import InactivityHandler from "./utils/InactivityHandler";

// pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// // ================================================================================
// // Check Auth
// const checkAuth = () => {
//   const token = localStorage.getItem("accessToken");
//   if (!token) {
//     console.log("Check auth returns False");
//     return false;
//   }
//   console.log("Token found:", token);
//   console.log("Check auth returns True");
//   return true;
// };

// // ================================================================================
// // Remove accessToken automatically on signin page
// // const RemoveTokenOnSignin = () => {
// //   const { pathname } = useLocation();

// //   useEffect(() => {
// //     if (pathname === "/signin") {
// //       console.log("Signin page detected → Clearing accessToken");
// //       localStorage.removeItem("accessToken");
// //     }
// //   }, [pathname]);

// //   return null;
// // };

// // ================================================================================
// // Auth Route Wrapper
// const AuthRoute = ({ children }) => {
//   const isAuthed = checkAuth();
//   return isAuthed ? children : <Navigate to="/signin" replace />;
// };

// // ================================================================================
// // App Component
// class App extends Component {
//   componentDidMount() {
//     if (
//       process.env.NODE_ENV === "production" ||
//       process.env.REACT_APP_ENV === "STAGING"
//     ) {
//       GlobalDebug(false);
//     }
//   }

//   render() {
//     return (
//       <React.Fragment>
//         <JwtProvider>
//           <Suspense
//             fallback={
//               <div>
//                 <div className="loader"></div>
//               </div>
//             }
//           >
//             {/* <RemoveTokenOnSignin /> */}
//             <InactivityHandler />

//             <TooManyRequestModal>
//               {/* Wrapping AllRoutes in AuthRoute is optional 
//                   — you can also guard individual routes */}
//               {/* <AuthRoute> */}
//                 <AllRoutes />
//               {/* </AuthRoute> */}
//             </TooManyRequestModal>
//           </Suspense>
//         </JwtProvider>
//       </React.Fragment>
//     );
//   }
// }

// App.propTypes = {
//   user_id: PropTypes.string,
//   userRole: PropTypes.string
// };

// function mapStateToProps(state) {
//   if (state.user) {
//     return {
//       user_id: state.user.id,
//       userRole: state.user.role
//     };
//   }
//   return {};
// }

// export default connect(mapStateToProps, {})(App);
